import { registerLocale } from 'react-datepicker'

import { codeToLocale } from './date-fns'

codeToLocale.forEach(({ code, locale }) => {
  registerLocale(code, locale)
})
